import React, {useState} from "react";
import {Offcanvas, OffcanvasBody, OffcanvasHeader} from "reactstrap";
import ListOrderRule from "./ListOrderRule";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import NoSearchResult from "../../../../../components/Common/NoSearchResult";
import {OrderRuleService} from "../../../../../services/order_rule.service";
import ServerPagination from "../../../../../components/Common/ServerPagination";

interface TrafficRulesProps {
    isOpen: boolean,
    toggle: () => void,
}

const TrafficRules: React.FC<TrafficRulesProps> = ({isOpen, toggle}) => {
    const queryClient = useQueryClient();

    const [filter, setFilter] = useState({per_page: 10, page: 1, sort_key: "id", sort_order: "desc", q: ""});

    const {data: orderRules, isLoading, isError} = useQuery({
        queryKey: ["keyRuleList", filter],
        queryFn: () => OrderRuleService.getRules(filter)
    });

    const updateFilter = (changes: Partial<typeof filter>) => {
        setFilter((prevFilter) => ({...prevFilter, ...changes}));
    };

    const invalidateOrderRules = async (type?: "create" | "edit" | "remove") => {
        const {pagination} = orderRules!;

        if (type === "edit") return queryClient.invalidateQueries({queryKey: ["keyRuleList", filter]});

        let newPage = pagination.current_page;

        if (type === "remove") {
            const itemsOnLastPage = pagination.total % pagination.per_page || pagination.per_page;
            const isOnlyItemOnLastPage = pagination.current_page === pagination.total_page && itemsOnLastPage === 1;

            if (isOnlyItemOnLastPage && pagination.current_page > 1) {
                newPage = pagination.current_page - 1;
            }
        }

        const newFilterKey = {...filter, page: newPage};

        return queryClient
            .invalidateQueries({queryKey: ["keyRuleList", newFilterKey]})
            .then(() => updateFilter({page: newPage}));
    };


    return (
        <Offcanvas isOpen={isOpen} direction="end" toggle={toggle}>
            <OffcanvasHeader toggle={toggle}> Traffic Rules </OffcanvasHeader>

            <OffcanvasBody>
                {!isLoading && orderRules
                    && <ListOrderRule orderRules={orderRules.data} invalidateOrderRules={invalidateOrderRules}/>}

                {!isLoading && orderRules?.data.length === 0 && (<NoSearchResult/>)}
                {isLoading && (<NoSearchResult text="Loading..."/>)}
                {isError && (<NoSearchResult/>)}

                {!isLoading && orderRules && orderRules.pagination.total_page > 1 && (
                    <ServerPagination
                        totalPages={orderRules.pagination.total_page}
                        page={orderRules.pagination.current_page}
                        onChange={(page) => updateFilter({page})}
                        className="mt-2"/>
                )}
            </OffcanvasBody>
        </Offcanvas>
    )
}

export default TrafficRules;